export const CLOSE_SNACKBAR = '@services/CLOSE_SNACKBAR';
export const OPEN_SNACKBAR = '@services/OPEN_SNACKBAR';

export const openSnackbar = (action) => {
    return (dispatch, getState) => {
        const state = getState();
        if (state) {
            dispatch({
                type: OPEN_SNACKBAR,
                action: action
            });
        } else return null;
    };
};

export const closeSnackbar = () => {
    return (dispatch, getState) => {
        const state = getState();
        if (state) {
            dispatch({
                type: CLOSE_SNACKBAR
            });
        } else return null;
    };
};
